import { makeStyles } from '@material-ui/core/styles';

// Shared presentation for registration and edit pages.
const useFormPageStyles = makeStyles(theme => ({
    content: {
        minWidth: 0,
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down('xs')]: { padding: theme.spacing(2) },
    },
    grid: {
        maxWidth: 1440,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    paper: {
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        backgroundColor: '#f8fafc',
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
    },
    form: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: { padding: theme.spacing(2) },
    },
    sectionTitle: {
        color: '#334155',
        fontSize: '1rem',
        fontWeight: 700,
    },
    formActions: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        borderTop: '1px solid #e5e7eb',
        [theme.breakpoints.down('xs')]: { '& > button': { width: '100%' } },
    },
    saveButton: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 44,
        minWidth: 180,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: { width: '100%' },
    },
}));

export default useFormPageStyles;
